// Vendor imports
const { connect } = require('react-redux')
// Shared imports
const { formatCount, pluralize } = require('shared/string-utils')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const articleModelConnect = require('client-v2/common/models/article/connect')
const userModelActions = require('client-v2/common/models/user/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Container state imports
const { getSlide } = require('../state/selectors')
const articleProfileSlideActions = require('../state/slide-actions')
const { TabNameEnum } = require('../state/slide-record')
// Sibling imports
const ArticleProfileDetailCard = require('./detail-card-dumb')

const Comments = pluralize('Comment')
const Interests = pluralize('Interest')

function mapStateToProps() {
  return function (state, props) {
    const slide = getSlide(state, props)
    return {
      article: slide.article,
      curatedAt: slide.curatedAt,
      curatedBy: slide.curatedBy,
      isCommentsVisible: state.user.hasRollout('article_profile_comments'),
      recReason: slide.articleMeta.recReason,
      tabs: {
        [TabNameEnum.COLLECTIONS]: collectionsTabState(slide),
        [TabNameEnum.COMMENTS]: commentsTabState(slide),
        [TabNameEnum.INTERESTS]: interestsTabState(slide)
      },
      user: state.user
    }
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    ...articleModelConnect.mapDispatchToProps(dispatch),
    onTabSelect: dispatchAction(articleProfileSlideActions.selectTab),
    onUserNavigate: dispatchAction(userModelActions.navigateToUserProfile)
  }
}

// Exports

const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    ArticleProfileDetailCard
  )
)

module.exports = SmartComponent

// Internal state helpers

function collectionsTabState(slide) {
  // Using Mixers Count to display the total number of users who added it
  // to their profile publicly instead of just the number of people who curated.
  const count = slide.article['mixers_count']
  const isLoading = slide.collectionsState === FetchStateEnum.LOADING
  const label = isLoading
  ? 'Mixed'
  : `${formatCount(count)} Mixed`
  return {
    isLoading,
    isSelected: slide.selectedTab === TabNameEnum.COLLECTIONS,
    label
  }
}

function commentsTabState(slide) {
  const count = slide.commentsItems.size
  const isLoading = slide.commentsState === FetchStateEnum.LOADING
  const label = isLoading
  ? 'Comments'
  : `${formatCount(count)} ${Comments(count)}`
  return {
    isLoading,
    isSelected: slide.selectedTab === TabNameEnum.COMMENTS,
    label
  }
}

function interestsTabState(slide) {
  const count = slide.interestsItems.size
  const isLoading = slide.interestsState === FetchStateEnum.LOADING
  const label = isLoading
  ? 'Interests'
  : `${formatCount(count)} ${Interests(count)}`
  return {
    count,
    isLoading,
    isSelected: slide.selectedTab === TabNameEnum.INTERESTS,
    label
  }
}
